/** Даты для экрана: время Москвы, как в CRM. */
const MSK = new Intl.DateTimeFormat("ru-RU", {
  timeZone: "Europe/Moscow",
  day: "2-digit",
  month: "2-digit",
  year: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
});

export function mskTime(iso: string | null): string {
  return iso ? MSK.format(new Date(iso)) : "—";
}

/** Дата `YYYY-MM-DD` по ЛОКАЛЬНОМУ времени: `toISOString()` вечером уносит день назад (копия supply). */
export function iso(date: Date): string {
  return [date.getFullYear(), String(date.getMonth() + 1).padStart(2, "0"), String(date.getDate()).padStart(2, "0")].join("-");
}

/** Дата через N дней — новый объект; `setDate` сам переносит месяц и год. */
export function plusDays(date: Date, days: number): Date {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
}

/** Календарная валидность `YYYY-MM-DD`: регулярка пропускает `2026-13-45`, `Date` его молча переносит. */
export function isValidDate(value: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const y = Number(value.slice(0, 4));
  const m = Number(value.slice(5, 7));
  const d = Number(value.slice(8, 10));
  const date = new Date(y, m - 1, d);
  return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d;
}
